var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 3.9987V3.46536C9.66667 2.71863 9.66667 2.34526 9.52134 2.06004C9.39351 1.80916 9.18954 1.60519 8.93865 1.47736C8.65344 1.33203 8.28007 1.33203 7.53333 1.33203H6.46667C5.71993 1.33203 5.34656 1.33203 5.06135 1.47736C4.81046 1.60519 4.60649 1.80916 4.47866 2.06004C4.33333 2.34526 4.33333 2.71863 4.33333 3.46536V3.9987M5.66667 7.66536V10.9987M8.33333 7.66536V10.9987M1 3.9987H13M11.6667 3.9987V11.4654C11.6667 12.5855 11.6667 13.1455 11.4487 13.5733C11.2569 13.9497 10.951 14.2556 10.5746 14.4474C10.1468 14.6654 9.58677 14.6654 8.46667 14.6654H5.53333C4.41323 14.6654 3.85318 14.6654 3.42535 14.4474C3.04903 14.2556 2.74307 13.9497 2.55132 13.5733C2.33333 13.1455 2.33333 12.5855 2.33333 11.4654V3.9987",
    stroke: "#FF5449",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a246ff436cf620c55b6d8dc29777952b.svg";
export { ForwardRef as ReactComponent };